import { render, staticRenderFns } from "./CouncilCardPosts.vue?vue&type=template&id=2bd9d38b&scoped=true&"
import script from "./CouncilCardPosts.vue?vue&type=script&lang=js&"
export * from "./CouncilCardPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd9d38b",
  null
  
)

export default component.exports